import React, { useEffect } from 'react'
import { Provider } from 'react-redux'
import { createWrapper } from 'next-redux-wrapper'
import { useSelector, useDispatch } from 'react-redux'
import { persistStore } from 'redux-persist'
import axios from 'axios'
import Router, { useRouter } from 'next/router'
import { PersistGate } from 'redux-persist/integration/react'
import Loader from 'react-loader-spinner'
import { ToastContainer } from 'react-toastify'
import tawkTo from 'tawkto-react'
import 'react-toastify/dist/ReactToastify.css'
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css'
import ErrorBoundary from '../components/ErrorBoundary'
import { pageview } from '../utils'
import {
  getFooterDetails,
  getProfileInfo,
  setServiceAddressDetails
} from 'actions'
import { Cookie } from '../components'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import '../styles/globals.css'
import { store } from 'reducers/store'
import ReactSignalR from '../utils/connectToSocket'
import { generateDeviceParams } from '../utils/generateDeviceParams'
import { HOMEPAGE_REGIONS_SUCCESS } from 'constants/actionTypes'
import { fetchRegions } from 'api'

const isProduction = process.env.NODE_ENV === 'production'

const persistor = typeof window !== 'undefined' ? persistStore(store) : false

const baseUrl = process.env.NEXT_PUBLIC_BASE_URL

axios.defaults.baseURL = baseUrl

NProgress.configure({
  minimum: 0.7,
  easing: 'ease',
  speed: 800,
  showSpinner: false
})

Router.events.on('routeChangeStart', () => {
  document.body.classList.toggle('loading')

  NProgress.start()
})
Router.events.on('routeChangeComplete', () => {
  document.body.classList.toggle('loading')

  NProgress.done()
})
Router.events.on('routeChangeError', () => {
  document.body.classList.toggle('loading')

  NProgress.done()
})

const AppComponent = ({ Component, pageProps }) => {
  const {
    data: { AccessToken },
    isAuthenticated
  } = useSelector((state) => state.auth)

  const getLayout = Component.getLayout || ((page) => page)

  const router = useRouter()

  const dispatch = useDispatch()

  const tawkToPropertyId = '60ad49bba4114e480ad0df72'

  const tawkToKey = '1f6ieg1n5'

  useEffect(() => {
    dispatch(getFooterDetails())

    if (isProduction) {
      tawkTo(tawkToPropertyId, tawkToKey)
    }

    ReactSignalR.connectToSocket()
  }, [])

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(getProfileInfo()).then(() => {
        dispatch(setServiceAddressDetails())
      })
    }
  }, [isAuthenticated])

  useEffect(() => {
    const handleRouteChange = (url) => {
      /* invoke analytics function only for production */
      if (isProduction) pageview(url)
    }
    router.events.on('routeChangeComplete', handleRouteChange)
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange)
    }
  }, [router.events])

  if (isAuthenticated)
    axios.defaults.headers.common = {
      Authorization: `Bearer ${AccessToken}`,
      ...generateDeviceParams()
    }

  return typeof window !== 'undefined' ? (
    <ErrorBoundary>
      <PersistGate
        persistor={persistor}
        loading={
          <div className="spinner">
            <Loader type="Oval" color="#000000" height={50} width={50} />
          </div>
        }
      >
        {getLayout(<Component {...pageProps} />)}
        <ToastContainer />
        <Cookie />
      </PersistGate>
    </ErrorBoundary>
  ) : (
    <Provider store={store}>
      {getLayout(<Component {...pageProps} />)}
      <ToastContainer />
      <Cookie />
    </Provider>
  )
}

AppComponent.getInitialProps = async (appContext) => {
  // const { data } = await fetchRegions()

  // store.dispatch({
  //   type: HOMEPAGE_REGIONS_SUCCESS,
  //   payload: data.regions
  // })

  let pageProps = {}
  if (appContext.Component.getInitialProps) {
    pageProps = await appContext.Component.getInitialProps(appContext.ctx)
  }
  return { ...pageProps }
}

// returns a new instance of store everytime its called
const makeStore = () => store
const wrapper = createWrapper(makeStore)

export default wrapper.withRedux(AppComponent)
